export default class UserController {
  constructor(UsersDataProvider) {
    "ngInject"
    this.UsersDataProvider = UsersDataProvider;
    this.currentPage = 1;
    this.pageLimit = '100';
    this.maxSize = 5;
    this.pageLimitOptions = {10: 10, 20: 20, 50: 50, 100: 100, 9999: 'All'};
    this.field = 'id';
    this.order_type = 'desc';
    this.col = 0;
    this.colTopDown = 0;
    this.getUsers();
  }

  getSortRecors(field, order_type, col, colTopDown) {
    this.field = field;
    this.order_type = order_type;
    this.col = col;
    this.colTopDown = colTopDown;
    this.getUsers();
  }

  getUsers() {
    let
      vm = this;
    let data = {};
    let searchData = {};
    searchData.id = vm.id;
    searchData.name = vm.name;
    searchData.email = vm.email;
    searchData.orgnumber = vm.orgnumber;
    searchData.company = vm.company;
    searchData.location = vm.location;
    searchData.mobile = vm.mobile;
    data.searchData = searchData;
    data.currentPage = vm.currentPage;
    data.pageLimit = vm.pageLimit;
    data.field = vm.field;
    data.order_type = vm.order_type;
    vm.UsersDataProvider.getUsers(data, searchData).then(function (result) {
      vm.users = result.data;
      vm.usersTotal = result.total;
      vm.selectall = false;
    });
  }

  clearFilter() {
    this.id = '';
    this.name = '';
    this.email = '';
    this.orgnumber = '';
    this.company = '';
    this.location = '';
    this.mobile = '';
    this.getUsers();
  }
}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/users/components/listing/controller.js
 **/